module.exports = {
	documents: [],
	categories: [],
	loadedCategories: {}
};
